import { render, staticRenderFns } from "./UploadRw5Zip.vue?vue&type=template&id=3c984e8d&scoped=true"
import script from "./UploadRw5Zip.vue?vue&type=script&lang=js"
export * from "./UploadRw5Zip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c984e8d",
  null
  
)

export default component.exports